/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Acrobatiek2Inputs */

const nl_enums_beweegthema_acrobatiek2 = /** @type {(inputs: Enums_Beweegthema_Acrobatiek2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acrobatiek`)
};

/**

* @param {Enums_Beweegthema_Acrobatiek2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_acrobatiek2 = /** @type {((inputs?: Enums_Beweegthema_Acrobatiek2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Acrobatiek2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_acrobatiek2(inputs)
});
export { enums_beweegthema_acrobatiek2 as "enums.Beweegthema.Acrobatiek" }